import { CONSTANTS } from "../../data";
import type { GameState } from "../../types";

export const inventoryReducer = (state: GameState, action: any): GameState => {
  switch (action.type) {
    case "BREW_SUCCESS": {
      const { resultItem, consumedItems, quantity = 1, qualityMultiplier } = action;
      const newInventory = { ...state.inventory };
      
      // Remove consumed items
      consumedItems.forEach(itemId => {
        const itemDef = CONSTANTS.ITEMS[itemId] || Object.values(CONSTANTS.RECIPES).find(r => r.result.id === itemId)?.result;
        if (itemDef?.consumable) {
          newInventory[itemId] = Math.max(0, (newInventory[itemId] || 0) - quantity);
        }
      });
      
      // Add result item
      newInventory[resultItem.id] = (newInventory[resultItem.id] || 0) + quantity;
      
      const newTimestamps = { ...state.lastCreationTimestamps, [resultItem.id]: Date.now() };
      
      let newQualityMultipliers = state.qualityMultipliers;
      if (qualityMultiplier) {
        const multipliers = [...(newQualityMultipliers[resultItem.id] || [])];
        for (let i = 0; i < quantity; i++) {
          multipliers.push(qualityMultiplier);
        }
        newQualityMultipliers = { ...newQualityMultipliers, [resultItem.id]: multipliers };
      }
      
      return {
        ...state,
        inventory: newInventory,
        lastCreationTimestamps: newTimestamps,
        qualityMultipliers: newQualityMultipliers,
      };
    }

    case "PURCHASE_ITEM": {
      const purchaseInventory = { ...state.inventory };
      purchaseInventory[action.itemId] = (purchaseInventory[action.itemId] || 0) + action.quantity;
      
      return {
        ...state,
        inventory: purchaseInventory,
        coins: state.coins - action.totalCost,
      };
    }

    case "DISCOVER_RECIPE": {
      // Find the recipe name for the notification
      const recipe = CONSTANTS.RECIPES[action.recipeId];
      const recipeName = recipe ? recipe.result.name : "Unknown Recipe";
      
      return {
        ...state,
        discoveredRecipes: [...state.discoveredRecipes, action.recipeId],
        lastDiscovery: { recipeId: action.recipeId, timestamp: Date.now() },
        discoveryNotification: {
          recipeName,
          timestamp: Date.now(),
        },
      };
    }

    case "SET_INVENTORY_TAB":
      return { ...state, inventoryActiveTab: action.tab };

    case "TOGGLE_INVENTORY_PANEL":
      return { ...state, inventoryPanelOpen: !state.inventoryPanelOpen };

    default:
      return state;
  }
};
